import {
	PqHeaderFrontend, ListFrontend, PqItemFrontend, ScoreFrontend,
	SectionFrontend, SettingsFrontend, SummaryFrontend
} from "@sabyr-dev/mist_core/view/frontend";
import { Attempt, Product, Question, Quiz } from "./datasource";
import { ChartFrontend } from "@sabyr-dev/mist_core/view/frontend/chart";

export class ElibraryHeaderFrontend extends PqHeaderFrontend<Question> { }

export class ElibraryListFrontend extends ListFrontend<Question> { }

export class ElibraryQuestionFrontend extends PqItemFrontend<Question> {
	getSwipeTarget(): NodeListOf<HTMLElement> {
		return document.querySelectorAll('notanelement');
	}
}

export class ElibrarySettingsFrontend extends SettingsFrontend<Question> { }

export class ElibraryScoreFrontend extends ScoreFrontend { }

export class ElibrarySectionFrontend extends SectionFrontend<Quiz, Question> { }

export class ElibrarySummaryFrontend extends SummaryFrontend<Product> { }

export class ElibraryChartFrontend extends ChartFrontend<Product, Attempt, Quiz> { }
